import { useNavigate } from "react-router-dom";

import { Button, Table } from "antd";
import dayjs from "dayjs";
import React, { useState } from "react";

import styles from "@/components/Dashboard/PawnTickets/PawnTickets.module.css";
import { DATE_FORMAT_DISPLAY, DashbaordTableData, IMAGES, ROUTES_URL } from "@/constant";
import { useAuth } from "@/hooks/useAuth";
import { useAuthStore } from "@/stores/authStore";
import { useRenewStore } from "@/stores/renewStore";
import { PawnTicket } from "@/types/authService";

interface PawnTicketsProps {
  pawnTickets: PawnTicket[];
}

const PawnTickets: React.FC<PawnTicketsProps> = ({ pawnTickets }) => {
  const navigate = useNavigate();
  const { currency } = useAuthStore();
  const setSelectedPledgeData = useRenewStore((state) => state?.setSelectedPledgeData);
  const setDownloanAmount = useRenewStore((state) => state?.setDownloanAmount);

  const [expandedRowKeys, setExpandedRowKeys] = useState([0]);
  const [downloadModal, setDownloadModal] = useState(false);

  const columns = [
    {
      title: "Ticket Number",
      dataIndex: "ticket_alpha_code",
      key: "ticket_alpha_code",
      render: (value: string) => <span>{value}</span>,
    },
    {
      title: "Ticket Date",
      dataIndex: "pledge_date",
      key: "pledge_date",
      render: (date: string) => (date ? dayjs(date).format(DATE_FORMAT_DISPLAY) : "-"),
    },
    {
      title: "Expiry Date",
      dataIndex: "pledge_expiry_date",
      key: "pledge_expiry_date",
      render: (date: string) => (date ? dayjs(date).format(DATE_FORMAT_DISPLAY) : "-"),
    },
    {
      title: `Interest (${currency})`,
      dataIndex: "total_interest_amount",
      key: "total_interest_amount",
      width: 120,
      render: (value: number | string) => <span>{value}</span>,
    },
  ];

  const getMonthDifference = (startDate: string, endDate: string): number => {
    const start = dayjs(startDate);
    const end = dayjs(endDate);

    if (!start.isValid() || !end.isValid()) return 0;

    let months = end.diff(start, "month");

    if (end.diff(start.add(months, "month"), "day") > 0) {
      months += 1;
    }

    return months;
  };

  const startRenewProcessHelper = (data?: PawnTicket): void => {
    if (!data?.id) {
      return;
    }

    // setSelectedPledgeData(data ?? null);
    setDownloanAmount(0);

    navigate(ROUTES_URL.CUSTOMER_CONCENT);
  };

  return (
    <div className={styles.tableWrapper}>
      <Table
        columns={columns}
        dataSource={pawnTickets}
        pagination={false}
        rowClassName={(_, index: number) => (index % 2 === 0 ? styles.evenRow : styles.oddRow)}
        // expandable={{
        //   expandedRowRender: (record: PawnTicket) => (
        //     <div className={styles.expandableBG}>
        //       <div className={styles.totalItems}>
        //         <div className={styles.months}>
        //           <img src={IMAGES.CALENDAR_ICON} className={styles.expandIcon} />
        //           <span className={styles.labelTitle}>Month(s)</span>
        //         </div>

        //         <span className={styles.values}>
        //           {getMonthDifference(record?.pledge_date, record?.pledge_expiry_date)}
        //         </span>

        //         <div className={styles.button}>
        //           <Button
        //             className={styles.clearButton}
        //             onClick={() => setDownloadModal(true)}
        //           >
        //             Downloan
        //           </Button>
        //           <Button
        //             className={styles.applyButton}
        //             htmlType="submit"
        //             disabled={!record?.is_active}
        //             onClick={() => startRenewProcessHelper(pawnTickets?.find(i => i.id === Number(expandedRowKeys[0])) ?? undefined)}
        //           >
        //             Renew
        //           </Button>
        //         </div>

        //         <div className={styles.fullLabel}>
        //           <img src={IMAGES.BRANCH_ICON} className={styles.expandIcon} />
        //           <span className={styles.labelTitle}>Branch</span>
        //         </div>
        //         <span className={styles.values}>{record?.bank_name}</span>

        //         <div className={styles.fullLabel}>
        //           <img src={IMAGES.TICKET_ICON} className={styles.expandIcon} />
        //           <span className={styles.labelTitle}>Ticket Amount</span>
        //         </div>
        //         <span className={styles.values}>S$ {record?.offered_pledge_amount}</span>

        //         <div className={styles.fullLabel}>
        //           <img src={IMAGES.ARTICLE_ICON} className={styles.expandIcon} />
        //           <span className={styles.labelTitle}>Article Description</span>
        //         </div>
        //         <span className={styles.values}>{record?.articles?.[0]?.description}</span>
        //       </div>
        //     </div>
        //   ),
        //   expandIconColumnIndex: columns.length,
        //   expandIcon: ({ expanded, onExpand, record }) =>
        //     expanded ? (
        //       <a onClick={(e) => onExpand(record, e)}>
        //         {" "}
        //         <img src={IMAGES.UP_ARROW} alt="up arrow" />{" "}
        //       </a>
        //     ) : (
        //       <a onClick={(e) => onExpand(record, e)}>
        //         {" "}
        //         <img src={IMAGES.DOWN_ARROW} alt="up arrow" />{" "}
        //       </a>
        //     ),
        //   expandedRowKeys,
        //   onExpand: (expanded, record) => {
        //     setExpandedRowKeys(expanded ? [record.key] : []);
        //   },
        // }}
      />
    </div>
  );
};

export default PawnTickets;
